import React from 'react';

const BlankLayout = (props) => {
    const { children } = props;
    return <div className="page_wrap blank_layout">{children}</div>;
};

export default BlankLayout;
